if (!customElements.get("td-default-product-atc-price")) {
  class TdDefaultProductAtcPrice extends HTMLElement {
    constructor() {
      super();
      
      /* Store unit price in cents from data attribute */
      this.unitPrice = parseInt(this.dataset.unitPrice) || 0;
      this.sectionId = this.dataset.sectionId || '';
      
      /* Element references */
      this.quantityInput = null;
      this.priceDisplay = null;
      this.stickyPriceDisplay = null;
    }

    connectedCallback() {
      this.initElements();
      this.initListeners();
    }

    initElements() {
      this.quantityInput = this.querySelector('input[name="quantity"]');
      this.priceDisplay = this.querySelector('[data-atc-price]');
      
      /* Find sticky ATC price display if it exists */
      const stickyAtc = document.querySelector('.td-default-product ~ th-sticky-atc');
      if (stickyAtc) {
        this.stickyPriceDisplay = stickyAtc.querySelector('[data-atc-price]');
      }

      if (!this.quantityInput || !this.priceDisplay) {
        return;
      }

      /* Set initial price */
      this.updatePrice();
    }

    initListeners() {
      if (!this.quantityInput) return;

      /* Listen for quantity input changes */
      this.quantityInput.addEventListener('change', () => this.updatePrice());
      this.quantityInput.addEventListener('input', () => this.updatePrice());

      /* Listen for plus/minus button clicks */
      const minusBtn = this.querySelector('.minus');
      const plusBtn = this.querySelector('.plus');

      if (minusBtn) {
        minusBtn.addEventListener('click', () => {
          setTimeout(() => this.updatePrice(), 10);
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', () => {
          setTimeout(() => this.updatePrice(), 10);
        });
      }

      /* Listen for variant change events (dispatched by product.js) */
      document.addEventListener('product:variant-change', (e) => {
        /* Only react to events from our own section */
        if (!e.detail || !e.detail.variant || !e.detail.variant.price) return;
        if (this.sectionId && e.detail.sectionId !== this.sectionId) return;
        
        this.unitPrice = e.detail.variant.price;
        this.updatePrice();
      });
    }

    updatePrice() {
      if (!this.quantityInput || !this.priceDisplay) return;

      const quantity = parseInt(this.quantityInput.value) || 1;
      const totalPrice = this.unitPrice * quantity;
      
      /* Use the theme's global formatMoney function */
      const format = window.theme?.settings?.money_with_currency_format || "${{amount}}";
      const formattedPrice = typeof formatMoney === 'function' 
        ? formatMoney(totalPrice, format)
        : this.fallbackFormatMoney(totalPrice);

      this.priceDisplay.textContent = formattedPrice;

      /* Update sticky ATC price if it exists */
      if (this.stickyPriceDisplay) {
        this.stickyPriceDisplay.textContent = formattedPrice;
      }
    }

    /* Fallback formatter if global formatMoney is not available */
    fallbackFormatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  customElements.define("td-default-product-atc-price", TdDefaultProductAtcPrice);
}
